import { Badge, BoxIcon, CreditCardIcon, Icon, ShopIcon, StarIcon } from "evergreen-ui";

// Custom tag colors for order types
const TAG_COLORS = {
  PREORDER: { backgroundColor: '#9b5cac', color: 'white' },
  BACKORDER: { backgroundColor: '#ff914d', color: 'white' },
  SINGLES: { backgroundColor: '#00af99', color: 'white' },
  STORE_PL: { backgroundColor: '#ffde59', color: '#333' },
  STORE_BV: { backgroundColor: '#3dc2ff', color: 'white' },
  REVIEW: { backgroundColor: '#fbbf24', color: '#333' }
};

export const PaymentBlock = (props) => (
  <Badge
    {...props}
    color={
      props.paymentStatus === "unpaid"
        ? "red"
        : props.paymentStatus === "partial_payment"
        ? "orange"
        : props.paymentStatus === "paid"
        ? "green"
        : props.paymentStatus === "payment_failed"
        ? "purple"
        : "neutral"
    }
  >
    {props.paymentType && props.paymentType.handler === 'card-gateway' && (
      <Icon icon={CreditCardIcon} size={12} marginRight={5} />
    )}
    {props.paymentStatusText}
  </Badge>
);

export const StatusBlock = (props) => (
  <Badge
    {...props}
    color={
      props.status === "placed"
        ? "red"
        : props.status === "confirmed"
        ? "orange"
        : props.status === "processed"
        ? "yellow"
        : props.status === "delivered"
        ? "teal"
        : props.status === "completed"
        ? "green"
        : props.status === "cancelled"
        ? "neutral"
        : props.status === "returning"
        ? "teal"
        : props.status === "returned"
        ? "purple"
        : "neutral"
    }
  >
    {props.statusText}
  </Badge>
);

export const TypeBlock = (props) => (
  <Badge
    {...props}
    color={
      props.orderType === "online"
        ? "blue"
        : props.orderType === "glovo"
        ? "yellow"
        : props.orderType === "phone"
        ? "blue"
        : props.orderType === "email"
        ? "blue"
        : props.orderType === "fizic"
        ? "purple"
        : "neutral"
    }
  >
    {props.orderTypeText}
  </Badge>
);

export const PreorderBlock = (props) => {
  return props.isPreorder === 1 ? <Badge style={TAG_COLORS.PREORDER}>P</Badge> : null;
};


export const BackorderBlock = (props) => {
  return props.isBackorder === 1 ? <Badge style={TAG_COLORS.BACKORDER}>CF</Badge> : null;
};

export const SinglesBlock = (props) => {
  let singles = false;
  let singlesCount = 0;
  for (let i in props.items) {
    if (props.items[i].type === "card") {
      singles = true;
      singlesCount += 1;
    }

    if(singlesCount > 99) {
      break;
    }
  }

  return singles ? <Badge style={TAG_COLORS.SINGLES}>S{singlesCount >= 99 ? '99+' : singlesCount}</Badge> : null;
};

const TROLL_EMAILS = [
  "faletifloreaionutvaletin@gmail.com",
  "cristidreghici1234@gmail.com",
  "dariussulea@gmail.com",
  "mariuskun97@gmail.com",
  "mihneageorgescu98@gmail.com",
  "alex.giurgiu@yahoo.com",
  "tudoranmihai00@gmail.com",
  "serbanalexandrucristian@yahoo.com",
  "alexandruzavoianu@gmail.com",
  "alisamoise19@yahoo.com",

];

const TROLL_PHONE_NUMBERS = [
  "0727752015",
  "0748428715",
  "0761336890",
  "0730164111",
  "0726833350",
  "0745894381",
  "0773720247",
  "0727167080",
  "0727457084",
  "0764136115"
];

export const AlertBlock = (props) => {
  if (
    TROLL_EMAILS.includes(props.email) ||
    TROLL_PHONE_NUMBERS.includes(props.billingPhoneNumber)
  ) {
    return <Badge color="black">Troll</Badge>;
  }

  return null;
};

export const CompanyBlock = (props) => {
  if(props.companyName) {
    return <Badge color="red">B2B</Badge>
  }
}

export const StorePickupBlock = (props) => {
  if (props.delivery === "personal" && props.locationId !== 2) {
    return (
      <Badge style={TAG_COLORS.STORE_PL}>
        <Icon icon={ShopIcon} size={12} marginRight={5}/> PL
      </Badge>
    );
  } else if(props.delivery === "personal-brasov" || (props.delivery === 'personal' && props.locationId === 2)) {
    return (
      <Badge style={TAG_COLORS.STORE_BV}>
        <Icon icon={ShopIcon} size={12} marginRight={5}/> BV
      </Badge>
    );
  } else if(props.delivery === "delivery-locker") {
    return <>
      <Badge>
        <Icon color="red" icon={BoxIcon} size={12} marginRight={5}/>
        EB
      </Badge>
    </>
  }

  return null;
};

export const EntityBlock = (props) => (
  <Badge
    {...props}
    colors={
      props.entityType === "pf"
        ? "teal"
        : props.entityType === "pj"
        ? "purple"
        : "neutral"
    }
  >
    {props.entityTypeText}
  </Badge>
);

export const DeliveryBlock = (props) => (
  <Badge
    {...props}
    colors={
      props.delivery === "delivery"
        ? "blue"
        : props.delivery === "personal"
        ? "green"
        : "neutral"
    }
  >
    {props.deliveryText}
  </Badge>
);

export const ReviewBlock = (props) => {
  if (props.review && props.review.rating) {
    return (
      <Badge style={{ backgroundColor: '#fbbf24', color: '#333' }}>
        <Icon icon={StarIcon} size={12} marginRight={4}/>
        {props.review.rating}
      </Badge>
    );
  }
  // Show gray star if no review
  return (
    <Icon icon={StarIcon} size={12} color="#9CA3AF" title="Fără recenzie"/>
  );
};
